import React, {useState} from "react";
import {EventBus} from "../../util/EventBus";
import {FormattedMessage} from "react-intl";
import * as StorageService from "../../services/StorageService";
import {LOCALSTORAGE_ITEMS} from "../../util/Constants";


function WelcomeDemoModal() {

    const visible = "visible";
    const hidden = "hidden";
    const [currentStyle, setCurrentStyle] = useState(hidden);
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [message2, setMessage2] = useState("");
    const [buttonText, setButtonText] = useState("");
    const modalWasShown = StorageService.getItem(LOCALSTORAGE_ITEMS.DEMO_ACCOUNT_MSG_WAS_SHOWN) === "true"? true:false;

    const openModal = (title, message, message2, buttonText) => {
        setCurrentStyle(visible);
        setTitle(title);
        setMessage(message);
        setMessage2(message2);
        setButtonText(buttonText);
    }
    const closeModal = () => {
        setCurrentStyle(hidden);
        setTimeout(() => {
            StorageService.setItem(LOCALSTORAGE_ITEMS.DEMO_ACCOUNT_MSG_WAS_SHOWN, "true");
        }, 1000); // WAIT UNTIL THE MODAL CLOSES THEN SET LOCALSTORAGE AND REMOVE MODAL FROM DOM
    }

    React.useEffect(() => {
        EventBus.on("welcomeDemoModal", (data) => {
            openModal(<FormattedMessage id="demoModalTitle"/>,<FormattedMessage id="demoModalTextFirstRow"/>, <FormattedMessage id="demoModalTextSecondRow"/>, <FormattedMessage id="OkGotIt"/>);
        });

        // Specify how to clean up after this effect:
        return function cleanup() {
            EventBus.remove("welcomeDemoModal");
        };
    },[]);


   if (modalWasShown) {
       return null;
   }
    return (
        <>
            <div className={currentStyle + " modal-overlay "} onClick={(e) => closeModal()}></div>
            <div className="modal welcome-demo-modal">
                <div className="row">
                <div className="modal-title big">{title}</div>
                </div>
                <div className="row">
                <p className="modal-text">{message}</p>
                </div>
                <div className="row">
                <p className="modal-text">{message2}</p>
                </div>
                <a className="btn btn-default mt-20" target="_blank" onClick={()=>closeModal()}>{buttonText}</a>
                </div>

        </>
    );

}



export default WelcomeDemoModal;
